module.exports = __webpack_public_path__ + "dcb9f04ec907bec0656f49616c9d26cb.png";